import styled from "styled-components"

import {Hr} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button"
import padding from "@irati/ui/src/global/padding"
import {greys} from "@irati/ui/src/global/colors"
import media from "@irati/ui/src/global/media"
import Card from "@irati/ui/src/Layout/Card"
import ProfilePicture from "@irati/ui/src/ProfilePicture"

import StatementItemComponent from "../StatementItem"

export const StyledStatementItem = styled(StatementItemComponent)`
  margin-bottom: ${padding.small};
`

export const StyledHr = styled(Hr)`
  margin: 25px 0 10px;

  ${media.tablet`
    border-top-color: ${greys.medium};
  `}
`

export const ShowMoreButton = styled(Button)`
  display: block;
  margin: 0 auto;
`

export const StyledCard = styled(Card)`
  margin-bottom: 20px;
  box-shadow: 0 4px 11px 0 rgba(82, 97, 115, 0.18);
`

export const StyledProfilePicture = styled(ProfilePicture)`
  margin-right: 45px;
  margin-left: 25px;
`
